module.exports = __webpack_public_path__ + "static/media/new-step-indicator-2of2.9792d261.svg";